import React from 'react';
import { Box, Typography } from '@mui/material';
import { PsychAppointmentBookingSourceFromString } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { ProviderMedicalRole } from '@uplift/types';
import { Spinner, ContextualNavigationLayout } from '@uplift/ui-v2';
import { useRouterQueryParam } from '@uplift/constants';
import { Redirect } from 'react-router';
import { FindPsychiatristPage } from './find-psychiatrist.page';
import { useFindPsychiatristPageStyles } from './styles';
import { useUserMatchesQuery } from '@uplift/queries';
import { useCurrentuser } from '@uplift/contexts';


export const CheckForPsychMatch: React.VFC = () => {
  const me = useCurrentuser();
  const sourceKey = useRouterQueryParam('source');
  const { classes } = useFindPsychiatristPageStyles();
  const { data: matches, isLoading } = useUserMatchesQuery(me.id);
  const l10n = useL10n();
  const source = PsychAppointmentBookingSourceFromString[sourceKey];

  if (isLoading) {
    return (
      <ContextualNavigationLayout>
        <Box className={classes.root}>
          <Box className={classes.header}>
            <Typography variant="h3">
              {l10n.findPsychiatrist.title}
            </Typography>
          </Box>
          <Box>
            <Spinner />
          </Box>
        </Box>
      </ContextualNavigationLayout>
    );
  }

  const hasPsychiatrist = matches.activeMatches?.find(x => x.provider.medicalRole === ProviderMedicalRole.psychiatrist);

  if (hasPsychiatrist) {
    return <Redirect to="/main" />;
  }

  return <FindPsychiatristPage source={source} />;
};
